import React from "react";
import { useEffect, useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { Services } from "../../api/Services";
import gymgirl from "../../images/gymgirl.jpg";
import { toast } from "react-toastify";
import UserStats from "./UserStats";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL_MEDIA } from "../../api/Constants";
import { BASE_URL_COMPETITION } from "../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';

const TrainerChallenges = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [Challenges, setChallenges] = useState([]);
  const [members, setMembers] = useState([]);
  const [memberModal, setMemberModal] = useState(false);
  const [search, setSearch] = useState("");
  const [duplicateMembers, setDuplicateMembers] = useState([]);
  const [userId, setUserId] = useState("");
  const [showModal, setShowModal] = useState(false);
  //api call for get trainer clients

  const filterUser = (e) => {
    setSearch(e.target.value);
    const value = e.target.value;
    const filteredResult = members?.filter((item) =>
      item.name.toLowerCase().includes(value.toLowerCase())
    );
    setMembers(value == "" ? duplicateMembers : filteredResult);
  };
  const getTrainerChallenges = async () => {
    setIsLoading(true);
    try {
      const result = await Services.getTrainerDashboardChallenges();
      console.log(result);
      if (result) {
        setChallenges(result?.data?.data);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  //api call for group members
  const getChallengeMembers = async (current_page, challenge_id) => {
    setIsLoading(true);
    try {
      const result = await Services.getTrainerChallengeMembers(
        (current_page = 1),
        challenge_id
      );

      if (result) {
        setMembers(result?.data?.data);
        setDuplicateMembers(result?.data?.data);

        setMemberModal(true);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getTrainerChallenges();
  }, []);
  const showUserStats = (id) => {
    //setUserId(id);
    //setShowModal(true);
    const metaToken = localStorage.getItem("token");
    const url = `${BASE_URL_COMPETITION}/user/${id}${metaToken ? "?token=" + metaToken : ""}`;
    window.open(url, "_blank");
  };
  return (
    <div className="dashboard-groups-wrapper">
      {userId && showModal && (
        <div className="trainer-modal-eventWrapper trainer-modal-eventWrapper-upper">
          <div className="trainer-modal trainer-modal-lg">
            <div className="close" onClick={() => setShowModal(false)}>
              <i className="fa fa-times"></i>
            </div>
            <UserStats userId={userId} />
          </div>
        </div>
      )}
      {isLoading && (
        <div className="loaderparent">
          <div className="loader"></div>
        </div>
      )}
      {memberModal && (
        <div className="trainer-modal-eventWrapper">
          <div className="trainer-modal">
            <div className="close" onClick={() => setMemberModal(false)}>
              <i className="fa fa-times"></i>
            </div>
            <div className="search px-2">
              <input
                type="text"
                className="form-control input"
                placeholder="Search user"
                value={search}
                onChange={filterUser}
              />
            </div>
            <ul className="list">
              {members?.map((member) => (
                <li key={member.id} onClick={() => showUserStats(member.id)}>
                  <div className="user-wrapper">
                    {member?.image ? (
                      <img
                        src={`${BASE_URL_MEDIA}/storage/assets/uploads/${member?.image}`}
                      />
                    ) : (
                      <div className="placerholder-small">
                        {member?.name.slice(0, 1)}
                      </div>
                    )}
                    <span className="name">{member?.name}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
      <div className="row">
        {Challenges?.map((item) => (
          <div className="col-12 mb-3">
            <div className="group-card">
              <div className="group-header challenge-header">
                {item?.image ? (
                  <img
                    src={getImageUrl(item?.image, BASE_URL_MEDIA)}
                  />
                ) : (
                  <img src={gymgirl} />
                )}

                <div className="info">
                  <p className="title">{item?.title}</p>

                  <p className="subtitle">{item?.type}</p>
                  <div className="activity">
                    <ul className="stats">
                      <li>
                        {" "}
                        <i class="fa-solid fa-people-group"></i>{" "}
                        {item?.members?.length} attending
                      </li>
                      <li>
                        {" "}
                        <i class="fa-regular fa-calendar-days"></i>{" "}
                        {item?.start_date}
                      </li>
                      <li>
                        <i class="fa-solid fa-file-lines"></i>{" "}
                        {item?.posts_count} posts
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {item?.members && (
                <div className="users-wrapper">
                  {item?.members?.slice(0, 5).map((member) =>
                    member?.image ? (
                      <img
                        onClick={() => getChallengeMembers(1, item?.id)}
                        src={`${BASE_URL_MEDIA}/storage/assets/uploads/${member?.image}`}
                        alt=""
                        srcset=""
                      />
                    ) : (
                      <div
                        onClick={() => getChallengeMembers(1, item?.id)}
                        className="placerholder-small"
                      >
                        {member?.name.slice(0, 1)}
                      </div>
                    )
                  )}
                  {item?.members?.length > 5 && (
                    <div
                      onClick={() => getChallengeMembers(1, item?.id)}
                      className="last-user"
                    >
                      {" "}
                      + {item?.members?.length - 5}{" "}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrainerChallenges;
